import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../atoms/Image';
import Copyright from '../../../../molecules/CopyrightLabel';

const CenterStackedFooter = props => {
  const { copyright, logo, bottomColor } = props;
  return (
    <div
      style={{
        textAlign: 'center',
        backgroundColor: bottomColor,
        paddingTop: '1.2em',
        paddingBottom: '1.2em',
      }}
    >
      <Copyright company={copyright.company} phrase={copyright.phrase} />
      <Image src={logo} centered size="small" style={{ paddingTop: '.9em' }} />
    </div>
  );
};

CenterStackedFooter.propTypes = {
  bottomColor: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
};

export default CenterStackedFooter;
